const contentFr = {
  "sections": [
    {
      "title": "‌LE TRAITEMENT DE VOS DONNEES",
      "content": [
        {
          "type": "p",
          "content": [
            {
              "type": "span",
              "content": "Nous accordons une grande importance à la protection de votre vie privée et de vos données. Nous nous engageons à offrir les standards les plus élevés en matière de produits et de services. Ainsi, nous apprécions chacun de nos clients existants ou potentiels et visons à maintenir une protection appropriée de vos données personnelles («"
            },
            {
              "type": "b",
              "content": "Données"
            },
            {
              "type": "span",
              "content": "»)."
            },
            {
              "type": "br",
              "content": ""
            },
            {
              "type": "br",
              "content": ""
            },
            {
              "type": "p",
              "content": [
                {
                  "type": "p",
                  "content": ""
                }
              ]
            },
            {
              "type": "p",
              "content": [
                {
                  "type": "span",
                  "content": "Le traitement de ces Données est effectué conformément aux dispositions du Règlement (UE) du Parlement européen et du Conseil du 27 avril 2016 (ci-après dénommé «"
                },
                {
                  "type": "b",
                  "content": "RGPD"
                },
                {
                  "type": "span",
                  "content": "») et à la loi française n° 78-17 du 6 janvier 1978 («"
                },
                {
                  "type": "b",
                  "content": "loi informatique et libertés"
                },
                {
                  "type": "span",
                  "content": "»)."
                }
              ]
            },
            {
              "type": "p",
              "content": [
                {
                  "type": "p",
                  "content": ""
                }
              ]
            }
          ]
        },
        {
          "type": "list_ordered",
          "content": [
            {
              "type": "span",
              "content": [
                {
                  "type": "b",
                  "content": "‌QUI EST LE RESPONSABLE DE TRAITEMENT DE DONNEES ?"
                },
                {
                  "type": "p",
                  "content": ""
                },
                {
                  "type": "span",
                  "content": "La société STRAGILIA éditeur du site "
                },
                {
                  "type": "span",
                  "content": [
                    {
                      "type": "a",
                      "href": "https://www.stragilia.com/",
                      "content": "https://www.stragilia.com/"
                    }
                  ]
                },
                {
                  "type": "span",
                  "content": " (ci-après le «"
                },
                {
                  "type": "b",
                  "content": "Site"
                },
                {
                  "type": "span",
                  "content": "») est le Responsable de traitement des Données (ci-après le «"
                },
                {
                  "type": "b",
                  "content": "Responsable de traitement"
                },
                {
                  "type": "span",
                  "content": "»)."
                },
                {
                  "type": "span",
                  "content": "En utilisant le Site, vous consentez et acceptez l’utilisation de vos Données par le Responsable de traitement, conformément à la présente Politique de confidentialité."
                },
                {
                  "type": "p",
                  "content": ""
                }
              ]
            },
            {
              "type": "span",
              "content": [
                {
                  "type": "b",
                  "content": "‌QUELLES SONT LES DONNEES COLLECTEES ?"
                },
                {
                  "type": "p",
                  "content": ""
                },
                {
                  "type": "span",
                  "content": "Lors de vos échanges avec le service client et plus généralement lors de votre navigation sur notre Site, le Responsable de traitement est amené à traiter vos informations, dont certaines sont de nature à vous identifier."
                },
                {
                  "type": "p",
                  "content": ""
                },
                {
                  "type": "p",
                  "content": [
                    {
                      "type": "span",
                      "content": "Il peut s’agir des Données suivantes :"
                    },
                    {
                      "type": "list_unordered",
                      "content": [
                        "Celles que vous nous avez communiqué directement : vos nom ; prénoms ; adresse postale ; adresse électronique ; numéro de téléphone ; identifiant et mot de passe crypté permettant l’identification sur le Site et vos préférences de contact concernant l'abonnement à notre newsletter.",
                        "Celles collectées automatiquement (cookies) : adresse IP et identifiants de l’équipement informatique ; système d’exploitation utilisé par le terminal ; type et version du logiciel de navigation utilisé ; date et heure de connexion au site.",
                        "Celles collectées lors de votre navigation sur le Site : l’historique de votre navigation (par exemple la date, l'heure de la connexion et/ou navigation, les pages visitées), le type de terminal et de navigateur, votre localisation, la langue du navigateur, le fournisseur d’accès, l’adresse IP."
                      ]
                    }
                  ]
                },
                {
                  "type": "p",
                  "content": ""
                },
                {
                  "type": "p",
                  "content": ""
                },
                {
                  "type": "span",
                  "content": "Nous ne collectons pas les Données sensibles comme les origines raciales ou ethniques, les opinions politiques, philosophiques ou religieuses, l’appartenance syndicale, les Données relatives à la santé, à la vie sexuelle ou aux infractions, condamnations et mesures de sûreté."
                }
              ]
            },
            {
              "type": "span",
              "content": [
                {
                  "type": "b",
                  "content": "‌QUELLES SONT LES FINALITES DU TRAITEMENT ?"
                },
                {
                  "type": "br",
                  "content": "‌"
                },
                {
                  "type": "span",
                  "content": "Vos Données sont utilisées pour plusieurs raisons, elles sont notamment traitées afin de"
                },
                {
                  "type": "span",
                  "content": "fournir et d’améliorer les services et produits que nous vous proposons."
                },
                {
                  "type": "p",
                  "content": ""
                },
                {
                  "type": "span",
                  "content": "Chaque traitement de vos Données est légalement fondé soit sur votre consentement, soit sur un contrat conclu avec vous, soit une obligation légale et/ou notre intérêt légitime prépondérant en fonction de la finalité du traitement."
                },
                {
                  "type": "p",
                  "content": ""
                },
                {
                  "type": "table",
                  "content": {
                    "headers": [
                      "Les finalités du traitement",
                      "Le fondement juridique"
                    ],
                    "rows": [
                      {
                        "col1": [
                          {
                            "type": "list_unordered",
                            "content": [
                              "Assurer l’usage des produits et services fournis par le Site",
                              "Gérer la relation clientèle et vos éventuelles réclamations",
                              "Gérer les demandes liées à l’exercice de vos droits en matière de Données personnelles"
                            ]
                          }
                        ],
                        "col2": "Un contrat"
                      },
                      {
                        "col1": [
                          {
                            "type": "list_unordered",
                            "content": [
                              "Profiter d’une expérience de navigation personnalisée à partir de votre historique d’achat et de votre navigation sur le Site"
                            ]
                          }
                        ],
                        "col2": "Votre consentement"
                      },
                      {
                        "col1": [
                          {
                            "type": "list_unordered",
                            "content": [
                              "Accéder au Site et son utilisation",
                              "Analyser et améliorer la qualité et la performance des services",
                              "Suivre l'utilisation du Site et améliorer de votre expérience",
                              "Préserver nos droits",
                              "Gérer les transactions et lutter contre la fraude",
                              "Élaborer des statistiques et segmentations, des études et des analyses afin d’améliorer la connaissance de nos clients"
                            ]
                          }
                        ],
                        "col2": "Notre intérêt légitime"
                      }
                    ]
                  }
                },
                {
                  "type": "p",
                  "content": ""
                }
              ]
            },
            {
              "type": "span",
              "content": [
                {
                  "type": "b",
                  "content": "‌QUI SONT LES DESTINATAIRES DE VOS DONNEES ?"
                },
                {
                  "type": "p",
                  "content": ""
                },
                {
                  "type": "span",
                  "content": "Les Données sont principalement destinées au Responsable de traitement, ses salariés pour l’exécution des finalités mentionnées à l’article 3, ainsi qu’aux sous-traitants qui sont les suivants :"
                },
                {
                  "type": "span",
                  "content": "Le prestataire d’hébergement : Google Cloud Platform (GCP). Ces services sont fournis et gérés par Google Ireland Limited, une société immatriculée en Irlande sous le numéro d’immatriculation 368047."
                },
                {
                  "type": "p",
                  "content": ""
                },
                {
                  "type": "b",
                  "content": "Adresse de Google Ireland Limited:"
                },
                {
                  "type": "p",
                  "content": [
                    {
                      "type": "span",
                      "content": "Gordon House, Barrow Street,"
                    },
                    {
                      "type": "p",
                      "content": "Dublin 4, Irlande."
                    },
                    {
                      "type": "list_unordered",
                      "content": [
                        [
                          "Les prestataires de paiement : STRIPE.",
                        ]
                      ]
                    },
                    {
                      "type": "p",
                      "content": "Le détail du traitement de ces Données par les prestataires est disponible aux liens suivants : Le prestataire d’hébergement : Google Cloud Platform (GCP). Ces services sont fournis et gérés par Google Ireland Limited, une société immatriculée en Irlande sous le numéro d’immatriculation 368047"
                    },
                    {
                      "type": "p",
                      "content": ""
                    },
                    {
                      "type": "b",
                      "content": "Adresse de Google Ireland Limited:"
                    },
                    {
                      "type": "p",
                      "content": [
                        {
                          "type": "span",
                          "content": "Gordon House, Barrow Street,"
                        },
                        {
                          "type": "p",
                          "content": "Dublin 4, Irlande."
                        }
                      ]
                    },
                    {
                      "type": "list_unordered",
                      "content": [
                        {
                          "type": "span",
                          "content": [
                            {
                              "type": "span",
                              "content": "Le prestataire de paiement"
                            },
                            {
                              "type": "list_unordered",
                              "content": [
                                {
                                  "type": "span",
                                  "content": [
                                    {
                                      "type": "span",
                                      "content": "STRIPE : "
                                    },
                                    {
                                      "type": "a",
                                      "href": "https://stripe.com/fr/privacy",
                                      "content": "https://stripe.com/fr/privacy"
                                    }
                                  ]
                                }
                              ]
                            }
                          ]
                        },
                      ]
                    },
                    {
                      "type": "p",
                      "content": "Le Responsable de traitements’engage à ne pas communiquer, céder ou transférer, à d’autres tiers les Données sans votre accord exprès. Cependant, elles pourront être communiquées pour se conformer à des obligations légales, réglementaires, judiciaires ou administratives."
                    }
                  ]
                }
              ]
            },
            {
              "type": "span",
              "content": [
                {
                  "type": "b",
                  "content": "‌PENDANT COMBIEN DE TEMPS CONSERVONS-NOUS VOS DONNEES ?"
                },
                {
                  "type": "br",
                  "content": "‌"
                },
                {
                  "type": "span",
                  "content": "Les Données sont conservées le temps nécessaire pour répondre aux finalités précitées, sans que la durée de conservation ne puisse excéder deux (2) ans à compter de la dernière interaction avec le Site. Le Responsable de traitement prend des mesures raisonnables pour assurer leur confidentialité."
                },
                {
                  "type": "span",
                  "content": "Une fois vos Données supprimées de notre base, certaines de vos Données pourront être conservées sous forme d'archive avec un accès restreint et strictement limité aux fins de satisfaire à nos obligations légales, comptables et fiscales, mais aussi pour gérer vos éventuelles réclamations et demandes de garanties dans la limite des délais de prescription applicable."
                },
                {
                  "type": "span",
                  "content": "Une fois que vos Données ne sont plus nécessaires au titre des finalités ou à des fins d'archivage pour satisfaire à nos obligations légales ou pour les besoins de la prescription applicable, vos Données seront anonymisées de manière irréversible."
                },
                {
                  "type": "p",
                  "content": ""
                },
                {
                  "type": "span",
                  "content": "À tout moment, vous avez la possibilité de nous demander la suppression de tout ou partie de vos Données, de vous opposer à leur traitement ou d’en demander la limitation, conformément à l’article 4 ci-dessus. En cas de demande de suppression de vos Données, celles-ci seront supprimées de notre base et conservées sous forme d’archive comme indiqué ci-dessus."
                },
                {
                  "type": "p",
                  "content": ""
                }
              ]
            },
            {
              "type": "span",
              "content": [
                {
                  "type": "b",
                  "content": "‌QUELS SONT LES DROITS DONT VOUS BENEFICIEZ S’AGISSANT DE VOSDONNEES ?"
                },
                {
                  "type": "br",
                  "content": "‌"
                },
                {
                  "type": "span",
                  "content": "Conformément à la loi informatique et liberté et au RGPD, vous bénéficiez et pouvez exercer les droits suivants auprès de nous :"
                },
                {
                  "type": "p",
                  "content": ""
                },
                {
                  "type": "list_unordered",
                  "content": [
                    "Droit d’accès : vous avez le droit de connaître les Données que nous détenons sur vous.",
                    "Droit de rectification : vous pouvez demander la rectification des informations inexactes ou incomplètes vous concernant. Il permet d’éviter que nous utilisons ou ne diffusons des informations erronées sur vous.",
                    "Droit à l’effacement : vous avez le droit de nous demander de supprimer vos Données (sous réserve des modalités exposées à l’article 8 ci-dessous)",
                    "Droit d’opposition : vous pouvez vous opposer à tout moment à ce que nous utilisons certaines de vos Données.",
                    "Droit à la portabilité : vous avez la possibilité de récupérer une partie de vos Données dans un format lisible par une machine. Vous pouvez librement stocker ailleurs ces Données portables ou les transmettre facilement d’un système à un autre, en vue d’une réutilisation à d’autres fins.",
                    "Droit à l’information : vous avez le droit d’être informé sur l’utilisation de vos Données."
                  ]
                },
                {
                  "type": "br",
                  "content": ""
                },
                {
                  "type": "br",
                  "content": ""
                },
                {
                  "type": "span",
                  "content": "Vous pouvez exercer vos droits en s’adressant au Responsable de traitement :"
                },
                [
                  {
                    "type": "list_unordered",
                    "content": [
                      {
                        type: "span",
                        content: [
                          {
                            type: "span",
                            content: "Par email à l’adresse électronique : "
                          },
                          {
                            type: "a",
                            href: "mailto:contact@stragilia.com",
                            content: "contact@stragilia.com",
                          }
                        ]
                      },
                      "Par courrier à l’adresse postale : STRAGILA 6 rue d’Armaillé 75017 PARIS France."
                    ]
                  },
                  {
                    "type": "br",
                    "content": ""
                  },
                  {
                    "type": "p",
                    "content": [
                      {
                        "type": "span",
                        "content": "Le Responsable de traitement fait héberger le Site auprès d’un prestataire spécialisé Google Cloud Platform (GCP). Ces services sont fournis et gérés par Google Ireland Limited dont les informations sont contenues dans les"
                      },
                      {
                        "type": "span",
                        "content": "Mentions Légales."
                      }
                    ]
                  },
                  {
                    "type": "br",
                    "content": ""
                  }
                ]
              ]
            },
            {
              "type": "span",
              "content": [
                {
                  "type": "b",
                  "content": "‌COMMENT LES DONNEES SONT-ELLES SECURISEES ?"
                },
                {
                  "type": "br",
                  "content": ""
                },
                {
                  "type": "span",
                  "content": "Le Responsable de traitement s’engage à prendre toutes les mesures techniques et organisationnelles pour assurer la protection et la sécurité des Données , en particulier contre toute perte, altération, diffusion ou usage illégal."
                },
                {
                  "type": "span",
                  "content": "Il s’assure également que les tiers auxquels il est susceptible de faire appel (prestataires techniques, fournisseurs) respectent cette exigence de protection des Données par la mise en place des mesures appropriées, conformément à la législation applicable. Les mesures techniques et organisationnelles mises en place peuvent inclure le recours à des formulaires d"
                },
                {
                  "type": "span",
                  "content": "’"
                },
                {
                  "type": "span",
                  "content": "inscription sécurisés, le cryptage de certaines Données (comme les Données bancaires), et l"
                },
                {
                  "type": "span",
                  "content": "’"
                },
                {
                  "type": "span",
                  "content": "accès restreint aux Données à caractère personnel."
                },
                {
                  "type": "span",
                  "content": "Enfin, nous vous invitons à la plus grande prudence dans la communication de vos Données,"
                },
                {
                  "type": "span",
                  "content": "identifiants et mots de passe personnels permettant l’accès au Site."
                },
                {
                  "type": "p",
                  "content": ""
                },
                {
                  "type": "span",
                  "content": "Certains messages ou sollicitations reçues peuvent provenir de personnes mal intentionnées cherchant à obtenir des informations personnelles vous concernant en vue d"
                },
                {
                  "type": "span",
                  "content": "’"
                },
                {
                  "type": "span",
                  "content": "une utilisation frauduleuse (pratique du phishing). Si vous recevez un message qui paraît être une tentative de phishing, vous êtes invité à ne pas y répondre et à ne pas ouvrir les pièces jointes, les"
                },
                {
                  "type": "span",
                  "content": "images ou les liens contenus dans le message. Vous pouvez le signaler par e-mail à "
                },
                {
                  "type": "span",
                  "content": [
                    {
                      "type": "a",
                      "href": "mailto:contact@stragilia.com",
                      "content": "contact@stragilia.com"
                    }
                  ]
                },
                {
                  "type": "span",
                  "content": " et sur "
                },
                {
                  "type": "span",
                  "content": [
                    {
                      "type": "a",
                      "href": "https://www.signal-spam.fr/",
                      "content": "www.signal-spam.fr"
                    }
                  ]
                },
                {
                  "type": "span",
                  "content": "."
                },
                {
                  "type": "p",
                  "content": ""
                }
              ]
            },
            {
              "type": "span",
              "content": [
                {
                  "type": "b",
                  "content": "‌TRANSFERT DES DONNEES PERSONNELLES"
                },
                {
                  "type": "br",
                  "content": ""
                },
                {
                  "type": "span",
                  "content": "Le Site est hébergé par Google Cloud Platform (GCP) sur des serveurs physiques en France et en Belgique. Les Données sont traitées via des logiciels et applicatifs divers par le Responsable de traitement. Ces logiciels et applicatifs sont hébergés sur des serveurs sécurisés en Europe dans des conditions conformes à la règlementation applicable."
                },
                {
                  "type": "span",
                  "content": "Dans le cas où des Données feraient l'objet d'un transfert dans un pays situé hors de l'Union Européenne, nous nous engageons à prendre les mesures techniques et organisationnelles nécessaires pour garantir le niveau de sécurité adéquat de vos Données comme si elles étaient restées au sein de l'Union Européenne."
                },
                {
                  "type": "p",
                  "content": ""
                }
              ]
            },
            {
              "type": "span",
              "content": [
                {
                  "type": "b",
                  "content": "‌MODIFICATION DE LA POLITIQUE DE CONFIDENTIALITÉ"
                },
                {
                  "type": "span",
                  "content": "Si la présente Politique de confidentialité est modifiée, la date de mise à jour de la Politique sera actualisée et indiquera le jour où les modifications ont été effectuées."
                },
                {
                  "type": "p",
                  "content": ""
                },
                {
                  "type": "span",
                  "content": "Si les modifications sont importantes, vous serez avertis au moyen d’un e-mail. La nouvelle version s’appliquera à compter de votre nouvelle connexion au Site."
                },
                {
                  "type": "p",
                  "content": ""
                },
                {
                  "type": "span",
                  "content": "En cas de litige, entre vous et le Responsable de traitement, la Politique à prendre en compte"
                },
                {
                  "type": "span",
                  "content": "sera celle en vigueur au moment des faits à l’origine du litige."
                },
                {
                  "type": "p",
                  "content": ""
                }
              ]
            },
            {
              "type": "span",
              "content": [
                {
                  "type": "b",
                  "content": "‌CONTACT"
                },
                {
                  "type": "p",
                  "content": [
                    {
                      "type": "span",
                      "content": "De manière générale, si vous avez des questions ou des commentaires concernant cette Politique ou quant à l’utilisation de vos Données par le Responsable de traitement, vous pouvez nous contacter à l’adresse suivante : STRAGILA 6 rue d’Armaillé 75017 PARIS France"
                    },
                    {
                      "type": "p",
                      "content": [
                        {
                          "type": "p",
                          "content": ""
                        }
                      ]
                    },
                    {
                      "type": "p",
                      "content": [
                        {
                          "type": "span",
                          "content": "Enfin, nous vous précisons qu’en cas de réclamation relative à la protection de vos Données Personnelles, vous pouvez également contacter l’autorité de contrôle française, la Commission Nationale de l’Informatique et des Libertés dont le site est accessible à l’adresse suivante: "
                        },
                        {
                          "type": "span",
                          "content": [
                            {
                              "type": "a",
                              "href": "https://www.cnil.fr/",
                              "content": "https://www.cnil.fr/"
                            }
                          ]
                        },
                        {
                          "type": "span",
                          "content": "."
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "title": "‌COOKIES",
      "content": [
        {
          "type": "p",
          "content": [
            {
              "type": "span",
              "content": "Lors de votre navigation sur notre site Internet, à l’adresse "
            },
            {
              "type": "span",
              "content": [
                {
                  "type": "a",
                  "href": "https://www.stragilia.com/",
                  "content": "https://www.stragilia.com/"
                }
              ]
            },
            {
              "type": "span",
              "content": " (le « Site »), des données de navigation peuvent être collectées, si nécessaire avec votre consentement préalable, à partir de cookies déposés sur notre Site. Pendant leur durée de vie, ces cookies permettront d’améliorer votre expérience. Cette rubrique a pour objectif de vous fournir une information claire et complète sur l’origine et l’usage des cookies qui sont déposés sur votre terminal (ordinateur fixe ou mobile, tablette, smartphone etc…) lorsque vous visitez notre Site et sur les moyens dont vous disposez si vous souhaitez vous y opposer."
            },
            {
              "type": "p",
              "content": [
                {
                  "type": "p",
                  "content": ""
                }
              ]
            }
          ]
        },
        {
          "type": "list_ordered",
          "content": [
            {
              "type": "span",
              "content": [
                {
                  "type": "b",
                  "content": "‌QU’EST-CE QU’UN COOKIE ?"
                },
                {
                  "type": "br",
                  "content": ""
                },
                {
                  "type": "span",
                  "content": "Un"
                },
                {
                  "type": "span",
                  "content": "cookie"
                },
                {
                  "type": "span",
                  "content": "(ou « traceur ») est un petit fichier informatique, déposé et lu lors de la consultation d’un site internet. Le terme"
                },
                {
                  "type": "span",
                  "content": "cookie"
                },
                {
                  "type": "span",
                  "content": "recouvre par exemple les"
                },
                {
                  "type": "span",
                  "content": "cookies"
                },
                {
                  "type": "span",
                  "content": "http, les"
                },
                {
                  "type": "span",
                  "content": "cookies"
                },
                {
                  "type": "span",
                  "content": "flash, le résultat du calcul d’empreinte, les pixels invisibles ou tout autre identifiant généré par un logiciel ou un système d’exploitation, par exemple."
                },
                {
                  "type": "p",
                  "content": ""
                }
              ]
            },
            {
              "type": "span",
              "content": [
                {
                  "type": "b",
                  "content": "‌QUELLES SONT LES FONCTIONNALITES DES COOKIES ?"
                },
                {
                  "type": "br",
                  "content": ""
                },
                {
                  "type": "span",
                  "content": "Les Cookies qui sont déposés sur le Site sont de plusieurs types et répondent chacun à des finalités différentes :"
                },
                {
                  "type": "p",
                  "content": ""
                },
                {
                  "type": "b",
                  "content": "Les cookies techniques"
                },
                {
                  "type": "span",
                  "content": " (dont cookies mesure d’audience) : ils permettent de savoir si vous êtes connecté ou non à votre espace client ou espace réservé, gestion de votre sélection de produits ou services… Le site est également susceptible d’utiliser des cookies de mesures de statistiques et d’audience destinées à déterminer le nombre de visiteurs et les rubriques visitées ;"
                },
                {
                  "type": "p",
                  "content": ""
                },
                {
                  "type": "b",
                  "content": "Les cookies optionnels"
                },
                {
                  "type": "span",
                  "content": ": Ils sont destinés à améliorer l’expérience utilisateur et à faciliter les recherches de l’utilisateur en proposant des produits et offres en lien avec ses centres d’intérêt."
                },
                {
                  "type": "span",
                  "content": "Les cookies publicitaires"
                },
                {
                  "type": "span",
                  "content": ": ils nous permettent, si vous les acceptez, d’afficher sur les pages web que vous consultez des publicités adaptées et personnalisées à votre profil et à vos centres d’intérêts sur des sites internet tiers comportant des espaces publicitaires. A cette fin, nous serons susceptibles de partager vos données de navigation avec nos partenaires y compris les réseaux sociaux. Ces publicités vous seront proposées compte tenu par exemple de votre historique de navigation, de vos achats, ou encore de vos données de localisation."
                },
                {
                  "type": "p",
                  "content": ""
                }
              ]
            },
            {
              "type": "span",
              "content": [
                {
                  "type": "b",
                  "content": "‌COMMENT PARAMETRER VOS COOKIES ?"
                },
                {
                  "type": "br",
                  "content": ""
                },
                {
                  "type": "span",
                  "content": "En dehors des Cookies strictement nécessaires au fonctionnement du Site, vous pouvez"
                },
                {
                  "type": "span",
                  "content": "décider, à tout moment d’accepter ou de refuser tout ou partie des"
                },
                {
                  "type": "span",
                  "content": "cookies"
                },
                {
                  "type": "span",
                  "content": "."
                },
                {
                  "type": "span",
                  "content": "Pour gérer vos cookies, vous pouvez accéder de notre outil de paramétrage des Cookies "
                },
                {
                  "type": "span",
                  "content": [
                    {
                      "type": "a",
                      "href": "https://stragilia.com/cookies",
                      "content": "https://stragilia.com/cookies"
                    }
                  ]
                },
                {
                  "type": "span",
                  "content": [
                    {
                      "type": "span",
                      "content": " directement sur votre navigateur en cliquant sur les liens disponibles ci-dessous :"
                    },
                    {
                      "type": "list_unordered",
                      "content": [
                        "Safari",
                        "Chrome",
                        "Firefox",
                        "Edge / Internet Explorer",
                        "iOS"
                      ]
                    }
                  ]
                },
                {
                  "type": "p",
                  "content": ""
                }
              ]
            },
            {
              "type": "span",
              "content": [
                {
                  "type": "b",
                  "content": "‌QUELLE EST LA DUREE DE VOTRE CONSENTEMENT RELATIF AUX COOKIES ?"
                },
                {
                  "type": "br",
                  "content": ""
                },
                {
                  "type": "span",
                  "content": "La durée de validité de votre consentement à la pose de Cookies est de six (6) mois à partir de votre choix. A l’expiration de cette durée, nous vous demanderons de renouveler votre consentement. Si vous n’avez exprimé aucun choix, nous pourrons vous solliciter à nouveau pour connaître vos intentions. En tout état de cause, vous gardez la possibilité de retirer votre consentement à tout moment en utilisant notre outil de paramétrage des Cookies."
                },
                {
                  "type": "p",
                  "content": ""
                }
              ]
            },
            {
              "type": "span",
              "content": [
                {
                  "type": "b",
                  "content": "‌QUELLES SONT LES CONSEQUENCES SI VOUS REFUSEZ LES COOKIES ?"
                },
                {
                  "type": "p",
                  "content": [
                    {
                      "type": "span",
                      "content": "En paramétrant vos Cookies dans l’outil de paramétrage ou dans votre navigateur, vous êtes susceptibles de modifier votre expérience de navigation sur le Site, et de ne plus profiter de certaines fonctionnalités. Par exemple, en refusant le dépôt des Cookies de performance et de personnalisation, votre navigation sur le Site ne sera plus adaptée à vos préférences notamment au regard des produits que vous avez visualisés. Nous déclinons par ailleurs toute responsabilité relative aux difficultés de navigation que vous pourriez rencontrer suivant votre décision de supprimer les Cookies."
                    }
                  ]
                }
              ]
            }
          ]
        },
      ]
    }
  ],
  "lastUpdated": "Dernière mise à jour : 01/01/2025",
}

export default contentFr
